import icList from '../../../assets/images/ic-list.svg'
import icX from '../../../assets/images/ic-x.svg'
import Popup from '../popup'
import clsx from 'clsx'
import { useClickOutside } from 'hooks/useClickOutside'
import RadioButton from '../radio-button'
import { Button } from 'avo-ui'
import { useState } from 'react'

const Sort = ({ className, classNamePopup, name = 'sort', options, value, onSelect }) => {
    const [show, setShow] = useState(false)

    const getLabel = () => {
        const findData = options?.find((item) => value === item?.key)
        return findData?.label
    }

    const onSelectOption = (value) => {
        if (onSelect) onSelect(value)
        setShow(false)
    }

    useClickOutside({
        callback: () => setShow(false),
        elementID: `sort-${name}`,
    })

    return (
        <div id={`sort-${name}`} className={clsx('relative', className)}>
            <Button title={getLabel() || 'Sort'} icon={icList} type={'outline'} onClick={() => setShow(!show)} />
            <Popup
                className={clsx('top-11 p-4', classNamePopup)}
                show={show}
                content={
                    <div className={'flex flex-col space-y-6'}>
                        <div className={'flex justify-between'}>
                            <div />
                            <p className={'font-semibold'}>Sort</p>
                            <img
                                className={'w-5 -mt-2 cursor-pointer'}
                                src={icX}
                                alt='ic-x'
                                onClick={() => setShow(false)}
                            />
                        </div>
                        <div className={'flex flex-col space-y-4'}>
                            {options.map((item) => (
                                <RadioButton
                                    key={item?.key}
                                    label={item?.label}
                                    name={item?.name}
                                    value={item?.key}
                                    checked={value === item?.key}
                                    onChange={({ value }) => onSelectOption(value)}
                                />
                            ))}
                        </div>
                    </div>
                }
            />
        </div>
    )
}

export default Sort
